import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { createSidePanelClient } from '../slices/google/actions';
const useSidePanelClient = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(createSidePanelClient());
  }, [dispatch]);
};
export default useSidePanelClient;